import React from 'react'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import FlutterHero from '../../layouts/Technologie/Flutterpage/FlutterHero'
import WhyChooseFlutter from '../../layouts/Technologie/Flutterpage/WhyChooseFlutter'
import FlutterBenefits from '../../layouts/Technologie/Flutterpage/FlutterBenefits'
import FlutterFeatures from '../../layouts/Technologie/Flutterpage/FlutterFeatures'
import FinalCTA from '../../layouts/FinalCTA'

const Fluttercustompage = () => {
  return (
    <>
    <Header/>
    <FlutterHero/>
    <WhyChooseFlutter/>
    <FlutterBenefits/>
    <FlutterFeatures/>
    <FinalCTA/>
    <Footer/>
    </>
  )
}

export default Fluttercustompage